import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.75 10.25v3.25q0 .319.216.534a.73.73 0 0 0 .534.216q.32 0 .534-.216a.73.73 0 0 0 .216-.534v-3.25h3.25q.319 0 .534-.216a.73.73 0 0 0 .216-.534.73.73 0 0 0-.216-.534.73.73 0 0 0-.534-.216h-3.25V5.5a.73.73 0 0 0-.216-.534.73.73 0 0 0-.534-.216.73.73 0 0 0-.534.216.73.73 0 0 0-.216.534v3.25H5.5a.73.73 0 0 0-.534.216.73.73 0 0 0-.216.534q0 .32.216.534a.73.73 0 0 0 .534.216zM9.502 19q-1.972 0-3.706-.748a9.6 9.6 0 0 1-3.016-2.03 9.6 9.6 0 0 1-2.032-3.016A9.25 9.25 0 0 1 0 9.502Q0 7.53.748 5.796a9.6 9.6 0 0 1 2.03-3.016A9.6 9.6 0 0 1 5.794.748 9.25 9.25 0 0 1 9.498 0q1.972 0 3.706.748a9.6 9.6 0 0 1 3.017 2.03 9.6 9.6 0 0 1 2.03 3.016A9.25 9.25 0 0 1 19 9.498q0 1.972-.748 3.706a9.6 9.6 0 0 1-2.03 3.017 9.6 9.6 0 0 1-3.016 2.03A9.25 9.25 0 0 1 9.502 19M9.5 17.5q3.35 0 5.675-2.325T17.5 9.5t-2.325-5.675T9.5 1.5 3.825 3.825 1.5 9.5t2.325 5.675T9.5 17.5"
    }, null, -1)
  ]))]))
}
export default { render: render }